import React from 'react';

const GridBackground = ({
  gridSize = 32,
  lineColor = 'rgba(59, 131, 246, 0.2)', // azul semi-transparente por defecto
  className = '',
}) => {
  return (
    <div
      // ... elemento absoluto que cubre el contenedor padre ...
      className={className}
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        backgroundImage: `
          linear-gradient(to right, ${lineColor} 1px, transparent 1px),
          linear-gradient(to bottom, ${lineColor} 1px, transparent 1px)
        `,
        backgroundSize: `${gridSize}px ${gridSize}px`,
        backgroundRepeat: 'repeat',
      }}
    />
  );
};

export default GridBackground;
